<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="fuelbalance_first_row_right_section mr-3 cus_bal"
          style="flex: 0 0 97%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%; height: 101px"
          >
            <div class="col-md-7 text-center">
              <h4 class="text-white">
                {{ $t("text.extendedReport.extendedReport") }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#4b2d73"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class="">
            <div class="row top_section_row mt-4" v-show="!showLoader">
              <div class="col-md-8">
                <span>
                  Extended Report between {{ this.startDate }} and
                  {{ this.endDate }}
                </span>
                <span> </span>
              </div>
              <div class="col-md-4 text-right"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="100" headerText="#"></e-column>
                <e-column
                  field="date"
                  :format="formatOptions"
                  type="date"
                  width="200"
                  :headerText="$t('text.fuelConsumption.date')"
                ></e-column>
                <e-column
                  field="week"
                  width="200"
                  :headerText="$t('text.fuelConsumption.week')"
                ></e-column>
                <e-column
                  field="voucherUser"
                  width="250"
                  :headerText="$t('text.fuelConsumption.email')"
                ></e-column>
                <e-column
                  field="chargeType"
                  width="200"
                  :headerText="$t('text.fuelConsumption.chargeType')"
                ></e-column>
                <e-column
                  field="chargeAmount"
                  format="N2"
                  width="200"
                  :headerText="$t('text.fuelConsumption.chargeAmount')"
                ></e-column>
                <e-column
                  field="description"
                  width="200"
                  :headerText="$t('text.fuelConsumption.description')"
                ></e-column>
                <e-column
                  field="currentBalance"
                  format="N2"
                  width="200"
                  :headerText="$t('text.fuelConsumption.currentBalance')"
                ></e-column>
                <e-column
                  field="state"
                  width="200"
                  :headerText="$t('text.fuelConsumption.state')"
                ></e-column>
                <e-column
                  field="voucherCardNumber"
                  width="200"
                  :headerText="$t('text.fuelConsumption.voucherPin')"
                ></e-column>
                <e-column
                  field="isUsed"
                  width="200"
                  :headerText="$t('text.fuelConsumption.voucherUsed')"
                ></e-column>
                <e-column
                  field="plateNumber"
                  width="200"
                  :headerText="$t('text.fuelConsumption.plateNumber')"
                ></e-column>
                <e-column
                  field="driver"
                  width="200"
                  :headerText="$t('text.fuelConsumption.driver')"
                ></e-column>
                <e-column
                  field="volSold"
                  format="N2"
                  width="200"
                  :headerText="$t('text.fuelConsumption.volume')"
                ></e-column>
                <e-column
                  field="priceSold"
                  format="N2"
                  width="150"
                  textAlign="Right"
                  :headerText="$t('text.fuelConsumption.pricePerLitre')"
                ></e-column>
                <e-column
                  field="voucherAmount"
                  format="N2"
                  width="250"
                  textAlign="Right"
                  :headerText="$t('text.fuelConsumption.voucherAmount')"
                ></e-column>
                <e-column
                  field="priceSoldCash"
                  format="N2"
                  width="250"
                  textAlign="Right"
                  :headerText="$t('text.fuelConsumption.amountPaid')"
                ></e-column>

                <e-column
                  field="branchName"
                  :headerText="$t('text.fuelConsumption.stationName')"
                  width="350"
                ></e-column>
                <e-column
                  field="state"
                  width="150"
                  textAlign="Right"
                  :headerText="$t('text.fuelConsumption.stationState')"
                ></e-column>
              </e-columns>
            </ejs-grid>

            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/online-money-transfer-isometric-wallets-with-coins_107791-121.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Extended Report:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      totalTransactions: null,
      tableDataCount: 10,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getExtendedReport();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getExtendedReport();
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Last 10 Transactions.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Last 10 Transactions.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getExtendedReport() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/ExtendedReport?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;
          response.data.forEach((el) => {
            ++index;
            el.state = el.state ? el.state : "";
            el.isUsed = el.isUsed ? el.isUsed : "";
            el.branchName = el.branchName ? el.branchName : "";
            if (!el.userState) {
              el.userState = "";
            }
            // if(el.volSold) {
            //     if (isFinite(el.volSold)) {
            //         el.volSold = el.volSold
            //         } else {
            //           el.volSold = 0.0;
            //         }
            // }
            // if(el.voucherAmount) {
            //     if (isFinite(el.voucherAmount)) {
            //         el.voucherAmount = el.voucherAmount
            //         } else {
            //         el.voucherAmount = 0.0;
            //     }
            // }
            // if(el.priceSoldCash) {
            //     if (isFinite(el.priceSoldCash)) {
            //         el.priceSoldCash = el.priceSoldCash
            //             .toFixed(2)
            //             .toString()
            //             .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            //         } else {
            //         el.priceSoldCash = 0.0;
            //     }
            // }
            el.index = index;
          });
          grid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
}
</style>
